module.exports = __webpack_public_path__ + "img/PlayButton.6057f8db.svg";